import getCodecNameFromCode from './get-codec-name-from-code';
export default async function codecImporter(codecCode) {
  const codecName = getCodecNameFromCode(codecCode);
  switch (codecName) {
    case 'dag-cbor':
      return import('@ipld/dag-cbor');
    case 'dag-pb':
      // @ts-expect-error - return types need normalizing
      return import('@ipld/dag-pb');
    case 'git-raw':
      return {
        decode: (await import('ipld-git')).default.util.deserialize
      };
    case 'raw':
      // @ts-expect-error - return types need normalizing
      return import('multiformats/codecs/raw');
    case 'json':
      return import('multiformats/codecs/json');
    case 'dag-json':
      return import('@ipld/dag-json');
    default:
      throw new Error(`unsupported codec: ${codecCode}=${getCodecNameFromCode(codecCode)}`);
  }
}